var render = function render(){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"page-footer"},[_c('small',[_vm._v(_vm._s(_vm._f("capitalize")(_vm.$t('poweredBy')))+"\n    "),_c('img',{attrs:{"src":_vm.arexoLogo,"height":"15"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }